<template>
    <div class="container p-0"><!-- pl-0 -->
        <div class="position-relative">
            <div class="history-setting">
              <button
                v-if="shouldShowActButton(1)"
                  :class="['history-settings-item', {'acts-btn-active' : showActsColumnStatus}]"
                  style="margin-bottom: 5px"
                  @click="showActsColumn($event)"
              >
                Додати поліси в АКТ
              </button>

              <button v-if="! isLoadData && (orders && orders.length > 0)"
                      style="margin-bottom: 5px"
                      class="history-settings-item excel"
                      @click="getXls()"
              >
                  <div>
                    <div v-if="isLoadXml"
                         class="option-loader spinner-border"
                         style="height: 22px; width: 22px; margin-right: 12px;"
                         role="status">
                    </div>
                    <ExcelIcon />
                  </div>
                  <span class="btn-text" style="margin-left: 6px;">
                    Експорт в Excel
                  </span>
              </button>


              <button v-if="! isLoadData && (orders && orders.length > 0)"
                      style="margin-bottom: 5px"
                      class="history-settings-item excel"
                      @click="getXls(true)"
              >
                <div>
                  <div v-if="isLoadXml"
                       class="option-loader spinner-border"
                       style="height: 22px; width: 22px; margin-right: 12px;"
                       role="status">
                  </div>
                  <ExcelIcon />
                </div>
                <span class="btn-text" style="margin-left: 6px;">
                    Зведений звіт
                  </span>
              </button>

<!--              <button-->
<!--                style="margin-bottom: 5px"-->
<!--                class="history-settings-item"-->
<!--                @click="$router.push({name: 'cancellation'})"-->
<!--              >-->
<!--                Запити на ануляцію-->
<!--              </button>-->

<!--              <button-->
<!--                style="margin-bottom: 5px"-->
<!--                class="history-settings-item"-->
<!--                @click="$router.push({name: 'reissue'})"-->
<!--              >-->
<!--                Запити на переоформлення-->
<!--              </button>-->

              <!-- shouldShowActButton(1) && -->
<!--              <a v-if=" showActsColumnStatus && Object.keys(this.margeActsList).length > 0" type="button" class="history-settings-item btn btn-orange filter-button" @click="generatePdfPreview" v-loading="loadAllDataTerminated || loadAllData">-->
<!--                Подати акт на виплату КВ-->
<!--              </a>-->


              <button @click="filterStatusWrap()" class="history-settings-item btn-filter">
                <!--                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--                    <rect y="4" width="24" height="2" fill="#24282C"/>-->
                <!--                    <rect y="18" width="24" height="2" fill="#24282C"/>-->
                <!--                    <circle cx="8" cy="5" r="4" fill="white" stroke="#24282C" stroke-width="2"/>-->
                <!--                    <circle cx="16" cy="19" r="4" fill="white" stroke="#24282C" stroke-width="2"/>-->
                <!--                </svg>-->
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 4H14" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10 4H3" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21 12H12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8 12H3" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21 20H16" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 20H3" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 2V6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8 10V14" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 18V22" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="btn-text">
                    {{ condition.isShowFilter ? 'Приховати' : 'Фільтри' }}
                  </span>
              </button>


              <div v-if="isMobile" class="history-view-mode">
                  <el-button v-if="ordersViewMode === 'compact'" class="history-view-btn" size="mini" @click="changeOrdersView">
                      <svg width="32" height="32" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 3H8C7.44772 3 7 3.44772 7 4V9C7 9.55228 7.44772 10 8 10H13C13.5523 10 14 9.55228 14 9V4C14 3.44772 13.5523 3 13 3Z" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13 14H8C7.44772 14 7 14.4477 7 15V20C7 20.5523 7.44772 21 8 21H13C13.5523 21 14 20.5523 14 20V15C14 14.4477 13.5523 14 13 14Z" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 4H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 9H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 15H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 20H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </el-button>
                  <el-button v-if="ordersViewMode === 'full'" class="history-view-btn" size="mini"  @click="changeOrdersView">
                      <svg width="32" height="32" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 12H7.01" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7 18H7.01" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M7 6H7.01" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 12H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 18H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 6H25" stroke="#717680" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                  </el-button>
              </div>
          </div>
        </div>
        <div class="insurance-history__menu__filters" style="display: flex; justify-content: space-between; flex-wrap: wrap;" >

        </div>
        <transition name="fade">
            <div v-show="condition.isShowFilter" class="menu filters mt-0 mb-4">
                <div class="row">
                    <div class="col-sm-4 form-group">
                        <div class="filter-title" style="">
                            Тип продукту
                        </div>
                        <el-select clearable v-model="listQuery.typeId"
                                   class="form-control-el"
                                   multiple placeholder="Виберiть тип продукту">
                            <el-option v-for="item in orderTypesList"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="col-sm-4 form-group">
                        <div class="filter-title" style="">
                            Компанії
                        </div>
                        <el-select v-model="listQuery.companyIds"
                                   class="form-control-el"
                                   multiple placeholder="Виберіть компанії">
                            <el-option v-for="item in companiesList"
                                       :key="item.id"
                                       :label="item.publicName"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="col-sm-4 form-group">
                        <div class="filter-title">
                            Дата створення
                        </div>
                      <DateInput
                        class="form-control-el w-100"
                        v-model="dateFilter"
                        type="input"
                        :range="true"
                        :disabled-future-dates="true"
                        placeholder="Виберіть дату"
                        @change="refreshDate"
                      />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 form-group">
                        <div class="filter-title">ПІБ клієнта</div>
                        <div>
                            <input class="form-control" v-model="listQuery.insurerName"/>
                        </div>
                    </div>
                    <div class="col-sm-4 form-group">
                        <div class="filter-title">МТСБУ код</div>
                        <div ><!-- class="form-group" -->
                            <input class="form-control" v-model="listQuery.mtsbuCode">
                        </div>
                    </div>
                    <div class="col-sm-4 form-group">
                        <div class="filter-title">Номер Авто</div>
                        <div>
                            <input class="form-control" v-model="listQuery.carNumber">
                        </div>
                    </div>
                </div>
                <div v-if="$store.getters.USER.organizationId "><!-- $store.getters.USER_INFO.organizationId -->
                    <OrganizationFilter v-model="listQuery.organizationId"></OrganizationFilter>
                </div>
                <div class="row">
                    <div class="col-sm-6 form-group" v-if="! isPartner() && !$store.getters.USER.organizationId">
                        <div class="filter-title">
                          Торгова точка
                        </div>
                        <el-select v-model="listQuery.partnerIds"
                                   class="form-control-el"
                                   multiple
                                   placeholder="Виберіть торгову точку">
                          <el-option v-for="item in partnersList"
                                     :key="item.id"
                                     :label="item.fullName"
                                     :value="item.id">
                          </el-option>
                        </el-select>
                    </div>
                    <div class="col-sm-6 form-group">
                        <div class="filter-title">ID договора</div>
                        <div class="form-group">
                          <input class="form-control" v-model="listQuery.orderId">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-4">
                        <div class="form-group">
                            <label>Тільки сплачені</label>
                            <div class="insurance__checked__group">
                                <span :class="['insurance__euro-toggle', 'only-payed-checkbox']">
                                    <input type="checkbox" id="euroCheckedParamsForm" v-model="listQuery.isPaid">
                                    <label for="euroCheckedParamsForm"><span>Відобразити тільки сплачені поліси, для формування актів</span></label>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
<!--                <hr>-->
                <div class="row">
                    <div class="col-sm-3 form-group mt-2">
                        <button @click="getList()" class="btn pl-0 w-100 btn-primary">
                            Застосувати
                        </button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { companyMixin, orderMixin, partnerMixin, userMixin } from '@/mixin';
import displaySettings from '@/mixin/displaySettings';
import { DateInput } from '@/shared/ui/form';
import { ExcelIcon } from '@/shared/ui/icons';
import OrganizationFilter from '@/views/history/components/OrganizationFilter.vue';
export default {
  components: { DateInput, Multiselect, OrganizationFilter, ExcelIcon },
  mixins: [userMixin, partnerMixin, companyMixin, orderMixin, displaySettings ],
  name: 'FilterBlock',
  props: ['isLoadXml', 'isLoadData', 'orders', 'initWhollyOrders', 'allOrders', 'dataListActs', 'loadAllData', 'ordersViewMode'],
  data: function () {
    return {
      dateFilter: new Date(),
      listActs: {},
      showActsColumnStatus: false,
      loadAllDataTerminated: false,
      condition: {
        isShowBlock: false,
        isShowFilter: false,
        isShowChildrenUser:false
      },
      listQuery: {
        userId: null,
        orderId: null,
        typeId: null,
        mtsbuCode: null,
        isPaid: false,
        carNumber: null,
        insurerName: null,
        partnerIds: null,
        //toDate: moment().calendar(),
        //fromDate: moment().subtract(7, 'days').calendar(),
        fromToDate: { 'fromDate' : moment().calendar(), 'toDate': moment().subtract(7, 'days').calendar() }
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      defaultDates: null,
    };
  },
  created() {
    const oneWeekAgo = new Date();
    const today = moment().format('DD-MM-YYYY');
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    oneWeekAgo.setHours(0, 0, 0, 0);
    this.defaultDates = [oneWeekAgo, moment()];
    this.dateFilter = [oneWeekAgo, moment()];


    if (this.userDefaultDates && this.userDefaultDates.expiresIn === today) {
      let userDateFrom = this.userDefaultDates.dateFrom ? moment(this.userDefaultDates.dateFrom, 'DD-MM-YYYY') : oneWeekAgo;
      let userDateTo = this.userDefaultDates.dateTo ? moment(this.userDefaultDates.dateTo, 'DD-MM-YYYY') : moment();
      this.dateFilter = [userDateFrom, userDateTo];
    } else {
      this.dateFilter = [oneWeekAgo, moment()];
    }

    //this.listQuery.fromDate = moment(this.dateFilter[0]).format(); //defaultUserFrom ??
    //this.listQuery.toDate =  moment(this.dateFilter[1]).format(); // defaultUserTo ??
    this.listQuery.fromToDate = { 'fromDate' : moment(this.dateFilter[0]).format(), 'toDate': moment(this.dateFilter[1]).format() };
  },
  watch: {
    dateFilter: function (newVal, oldVal) {
      this.setHistoryDates(newVal);
    },
  },
  computed: {
    margeActsList: function () {
      return {
        ...this.dataListActs,
        ...this.listActs,
      };
    },
    partnersList() {
      return this.$store.getters.ALL_PARTNERS;
    },
    orderStatuses() {
      return this.$store.getters.ORDER_STATUSES;
    },
    orderTypesList() {
      return this.$store.getters.ALL_ORDER_TYPES;
    },
    userDefaultDates() {
      return this.$store.getters.HISTORY_DATES;
    },
    amountBalance() {
      return this.$store.state.transactionsStore.all.amount;
    },
  },
  methods: {
    async showActsColumn(){
      this.showActsColumnStatus = !this.showActsColumnStatus;
      if(this.showActsColumnStatus){
        await this.selectAllTerminatedAkts();
        this.$emit('init-list-acts-terminate',this.listActs);
      }
      return this.$emit('show-acts-column', this.showActsColumnStatus);
    },
    generatePdfPreview() {
      if(this.loadAllData || this.loadAllDataTerminated) return;
      this.$emit('generate-pdf-preview');
    },
    changeOrdersView(mode) {
      this.$emit('change-orders-view');
    },
    getQuery() {
      //this.listQuery.fromDate = moment(this.dateFilter[0]).format();
      //this.listQuery.toDate =  moment(this.dateFilter[1]).format();
      this.listQuery.fromToDate = { 'fromDate' : moment(this.dateFilter[0]).format(), 'toDate': moment(this.dateFilter[1]).format() };
      return this.listQuery;
    },
    refreshDate: function() {
      //this.listQuery.fromDate = moment(this.dateFilter[0]).format();
      //this.listQuery.toDate =  moment(this.dateFilter[1]).format();
      this.listQuery.fromToDate = { 'fromDate' : moment(this.dateFilter[0]).format(), 'toDate': moment(this.dateFilter[1]).format() };
    },
    applyDateFromQuery(dateFrom) {
      const parsedFrom = moment(dateFrom, 'YYYY-MM-DD');
      if (!parsedFrom.isValid()) return;
      this.dateFilter = [parsedFrom.toDate(), moment().toDate()];
    },
    filterStatusWrap: function(scroll = false) {
      this.condition.isShowFilter = ! this.condition.isShowFilter;

      if (scroll) {
        let filter = this.$el.querySelector('.insurance-history__menu__filters');
        filter.scrollTop = filter.scrollHeight;
      }
    },
    setHistoryDates(dates) {
      let defaultFrom = moment(this.defaultDates[0]).format('DD-MM-YYYY');
      let defaultTo = moment(this.defaultDates[1]).format('DD-MM-YYYY');

      let filterDateFrom = moment(this.dateFilter[0]).format('DD-MM-YYYY');
      let filterDateTo = moment(this.dateFilter[1]).format('DD-MM-YYYY');
      let expiresIn = moment().format('DD-MM-YYYY');

      let historyDates = {
        dateFrom: filterDateFrom,
        dateTo: filterDateTo,
        expiresIn: expiresIn,
      };

      if (filterDateFrom !== defaultFrom) {
        this.$store.commit('SET_ORDERS_HISTORY_DATES', historyDates);
      }
    },
    getXls : function(isTiny = false) {
      this.listQuery.isTiny = isTiny;
      return this.$emit('download-xls');
    },
    getList() {
      this.condition.isShowFilter = false;
      return this.$emit('init-orders-list');
    },
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
    opacity: 0;
}

.clients button {
    display: initial;
}

.filter-button {
    margin: 0;
    padding: 6px 39px;
    color: white;
    font-size: 14px;
}

::v-deep .date-input--input {
  border: 1px solid #dde2e5 !important;
  border-radius: 3px !important;

  &:hover {
    border-color: #ffad3d !important;
  }
}
</style>
<style>
.wide-alert-dialog {
    width: 600px !important;
}

.wide-alert-dialog h3 {
    text-align: center;
    font-weight: bold;
    color: black
}

.wide-alert-dialog p.content-box {
    font-size: 20px;
    padding: 6px 6px;
}

.wide-alert-dialog .el-message-box__btns {
    display: flex !important;
    justify-content: center !important;
    border-radius: 3px;
}

.wide-alert-dialog .el-message-box__btns button {
    padding: 11px 56px !important;
    border-color: initial !important;
    color: #fff;
    background: #FFAD3D;
    font-size: 16px;
    border-radius: 3px;
}
</style>

<style scoped lang="scss">


.history-setting {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 16px 16px;
  position: unset;
  top: unset;
  right: unset;
  margin-bottom: 10px;

  .history-settings-item {
    &.excel {
      display: flex;
      justify-content: flex-start;
    }
    &.btn-filter {
      text-align: left;
      width: 85%;
    }
    .filter-view-block {

    }

    &.acts-btn-active {
      color: #FB923C;
    }
  }



  @media (min-width: 1320px) {
    position: absolute;
    flex-wrap: nowrap;
    top: -85px;
    right: 0;
    margin-bottom: 10px;

    .history-settings-item {
      width: auto;
      &.btn-filter {
        width: 120px;
        margin-bottom: 5px;
      }
    }
  }
  @media (max-width: 500px) {
    justify-content: space-between;
    gap: 12px 8px;
    .history-settings-item {
      text-align: left;
      width: 48%;
      &:nth-child(odd) {
        width: 43%;
      }
    }
  }
  @media (max-width: 350px) {
    justify-content: space-between;
    .history-settings-item {
      width: 100%;
      &:nth-child(odd) {
        width: 100%;
      }
    }
  }

  button, a {
    font-size: 15px;
    font-weight: 600;

    .btn-text {
      margin-left: 4px;
    }
    svg {
      margin-top: -2px;
    }
  }

  .btn-filter {
    font-size: 16px;
    font-weight: normal;
  }

}


.only-payed-checkbox {
  display: flex;
  font-weight: bold;
  label {
    display: flex;
    font-weight: bold;
    height: auto;

    &:before {
      width: 19px;
      margin-top: 2px;
    }
    &:after {
      //display: inline-block;
    }
  }

}

</style>
